import 'angular:locale/data:es-mx';
import 'angular:locale/data:en-us';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
